/**
 * Creates a [[BemClassBuilder]] instance for a BEM **block**.
 * @param blockName The CSS class name of the BEM **block**.
 */
export const bemClassBuilder = (blockName) => {
    return {
        block: (modifiers, additionalClass) => {
            return getClassString(blockName, modifiers, additionalClass);
        },
        element: (elementName, modifiers, additionalClass) => {
            return getClassString(getElementClass(blockName, elementName), modifiers, additionalClass);
        }
    };
};
const bemElementSeparator = '__';
const bemModifierSeparator = '--';
const getClassString = (baseClass, modifiers, additionalClass) => {
    const modifierClasses = modifiers ? getModifierClasses(baseClass, modifiers) : [];
    const classes = [baseClass, ...modifierClasses];
    if (!!additionalClass && additionalClass.length > 0)
        classes.push(additionalClass);
    return classes.join(' ');
};
const getModifierClasses = (baseClass, modifiers) => {
    return Object.entries(modifiers).reduce((acc, [name, value]) => {
        const modifierValue = getModifierValue(name, value);
        if (!!modifierValue && modifierValue.length > 0)
            acc.push(getModifierClass(baseClass, modifierValue));
        return acc;
    }, []);
};
const getElementClass = (blockName, elementName) => {
    return `${blockName}${bemElementSeparator}${elementName}`;
};
const getModifierClass = (baseClass, modifierValue) => {
    return `${baseClass}${bemModifierSeparator}${modifierValue}`;
};
const getModifierValue = (name, value) => {
    if (!value)
        return undefined;
    const kebabName = convertToKebabCase(name);
    return typeof value === 'string' ? `${kebabName}-${convertToKebabCase(value)}` : kebabName;
};
const convertToKebabCase = (name) => {
    return name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};
//# sourceMappingURL=bem-class-builder.js.map